/**
 * Contact popup: intercepts .cta-mail links (mailto stays the no-JS fallback),
 * lazy-loads Turnstile on first open, posts to the REST endpoint.
 */
document.addEventListener("DOMContentLoaded", function () {
  const dialog = document.getElementById("nm-contact");
  if (!dialog || typeof dialog.showModal !== "function") return;

  const form = dialog.querySelector("form");
  const status = dialog.querySelector(".nm-contact__status");
  const submit = form.querySelector("[type=submit]");
  const sitekey = dialog.dataset.sitekey;
  let openedAt = 0;
  let widgetId = null;

  function loadTurnstile() {
    if (!sitekey || widgetId !== null || window.nmTurnstileLoading) return;
    window.nmTurnstileLoading = true;
    window.nmTurnstileReady = function () {
      widgetId = window.turnstile.render(dialog.querySelector(".nm-contact__turnstile"), {
        sitekey: sitekey,
        appearance: "interaction-only",
      });
    };
    const script = document.createElement("script");
    script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=nmTurnstileReady";
    document.head.appendChild(script);
  }

  document.addEventListener("click", function (e) {
    const link = e.target.closest("a.cta-mail");
    if (!link) return;
    e.preventDefault();
    openedAt = Date.now();
    dialog.showModal();
    loadTurnstile();
  });

  // Close on button or backdrop click
  dialog.addEventListener("click", function (e) {
    if (e.target === dialog || e.target.closest("[data-close]")) dialog.close();
  });

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    if (!form.reportValidity()) return;

    const data = Object.fromEntries(new FormData(form));
    data.elapsed = Math.round((Date.now() - openedAt) / 1000);
    data.source = window.location.href;

    submit.disabled = true;
    status.classList.remove("-success");
    status.textContent = "Envoi en cours...";

    fetch(form.action, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
      // Give up after 20s instead of spinning forever (guard for older Safari)
      signal: AbortSignal.timeout ? AbortSignal.timeout(20000) : undefined,
    })
      .then((r) => r.json())
      .then((res) => {
        if (res.ok) {
          form.reset();
          status.classList.add("-success");
          status.textContent = "Votre message a bien été transmis, je vous réponds rapidement !";
          // GA4 recommended lead event; gtag comes from Site Kit (absent for logged-in users)
          if (typeof window.gtag === "function") {
            window.gtag("event", "generate_lead", { form_name: "contact_popup" });
          }
        } else {
          status.textContent = res.message || "L'envoi a échoué.";
        }
      })
      .catch(() => {
        status.textContent = "L'envoi a échoué. Écrivez-moi directement à l'adresse ci-dessous.";
      })
      .finally(() => {
        submit.disabled = false;
        // Turnstile tokens are single-use
        if (widgetId !== null) window.turnstile.reset(widgetId);
      });
  });
});
